import { type LookupKind, recordLookup } from "./lookup-visit.js";
import { hasSession } from "./save-word.js";

/**
 * A canonical 词典 entry or 例句 page reporting that a reader arrived on it.
 *
 * One visit per document, posted once the document is visible. What the
 * request is and how it retries is `lookup-visit.ts`, which the word segmenter
 * shares.
 */

const started = new WeakSet<Document>();

/**
 * The pages that carry a visit, named by the kind each of them is.
 *
 * The two kinds are spelled here rather than read off the element, so that
 * what the selector finds and what the request says cannot come apart. A page
 * marked with any other kind is a page this does not report.
 */
const carriesVisit =
  '[data-lookup-kind="ci"][data-lookup-id], [data-lookup-kind="liju"][data-lookup-id]';

export function startLookupHistory(
  document: Document,
  fetched: typeof fetch = globalThis.fetch,
): void {
  const entry = document.querySelector<HTMLElement>(carriesVisit);
  if (!entry || started.has(document) || !hasSession(document)) {
    return;
  }
  const kind: LookupKind =
    entry.dataset["lookupKind"] === "liju" ? "liju" : "ci";
  const id = entry.dataset["lookupId"] ?? "";
  const record = (): void => {
    if (document.visibilityState !== "visible" || started.has(document)) {
      return;
    }
    started.add(document);
    recordLookup(fetched, { kind, id });
  };
  record();
  document.addEventListener("visibilitychange", record);
}
